import React from "react";

const Subtitle = ({ subtitle }) => {
  return <div className="subtitle section__subtitle">{subtitle}</div>;
};

export default Subtitle;
